import { GroupId } from '@sr/types';
import { useFocusActiveElement } from '../shared/focus-utils';
import MessageGroup from './MessageGroup';
import { GroupAppearTransition } from './transitions';
import useStore from 'store';
import { Box } from 'v1/ui';

const groupIds: GroupId[] = [
  'impact',
  'completeness',
  'formatting',
  // 'correctness',
  'best-practices',
];

export default function Summary() {
  const activeGroupId = useStore.useActiveGroupId();

  // Focus on the new element when the activeMessageId changes
  useFocusActiveElement();

  return (
    <Box sx={{ overflow: 'hidden' }}>
      {groupIds.map((groupId, index) => (
        <GroupAppearTransition key={groupId} index={index}>
          <div>
            <MessageGroup
              active={groupId === activeGroupId}
              groupId={groupId}
              key={groupId}
            />
          </div>
        </GroupAppearTransition>
      ))}
    </Box>
  );
}
